<template>
  <div
    class="dropdown"
    tabindex="-1"
    @focusout="handleFocusOut"
  >
    <div class="dropdown-wrapper">
      <div
        v-for="(group, index) in filterGroups"
        :key="group.label || group.filters[0]?.label"
        class="dropdown-item"
      >
        <p
          v-if="group.label"
          class="dropdown-item-title"
        >
          {{ group.label }}
        </p>
        <div
          v-for="filter in group.filters"
          :key="filter.label"
        >
          <a
            href="#"
            class="dropdown-item"
            :data-testid="'name-' + filter.label"
            @click="() => $emit('add-new-filter', filter.label, group.label)"
          >
            {{ filter.label }}
          </a>
        </div>
        <hr
          v-if="index !== filterGroups.length - 1"
          class="dropdown-divider"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterGroups',
  props: {
    filterGroups: {
      type: Array,
      required: true,
    },
  },
  emits: ['add-new-filter', 'close-options'],
  mounted() {
    this.$el.focus();
  },
  methods: {
    handleFocusOut() {
      // Don't close options if a child of '.dropdown' is focused or selected
      if (this.$el.matches(':focus-within')) return;
      this.$emit('close-options');
    },
  },
};

</script>

<style scoped lang="scss">
  .dropdown {
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
    border-radius: 2px;
    display: flex;
    top: 8px;
    left: -2px;
    background-color: white;
    z-index: 10;
    padding: 8px 0px 8px 20px;
    overflow-x: hidden;
    &-wrapper {
      position: relative;
      max-height: 450px;
    }
    &-item {
      text-align: left;
      font-size: 14px;
      overflow: hidden;
      width: 245px;
      color: main.$npGray;
      text-decoration: none;
      &-title {
        font-weight: bold;
        color: main.$npGray;
      }
    }
    & a {
      display: block;
      margin: 4px 0 4px 10px;
    }
    & hr {
      margin-top: 10px;
    }
  }
</style>
